import type { Slide } from '@/entities/deck'
import type { DeepReadonly } from 'vue'

export interface UseTeaserSlides {
  startSlideAutoPlay(): void
}

interface Params {
  teaserSlides: DeepReadonly<Slide[]>
  intervalTime: number
  setActiveScene: (modelId: number, cameraId: number | null) => void
}

export function useTeaserSlides({ teaserSlides, setActiveScene, intervalTime = 8000 }: Params): UseTeaserSlides {
  let indexOfTeaserSlide = 0
  let abortTimeout = false

  function startSlideAutoPlay() {
    // Smooths out initial transition so that things don't get wild when the model first loads
    setTimeout(() => {
      const slide = teaserSlides[++indexOfTeaserSlide % teaserSlides.length]
      if (slide.model_id) {
        setActiveScene(slide.model_id, slide.camera_id)
      }
    }, 250)

    timeout(() => {
      const slide = teaserSlides[++indexOfTeaserSlide % teaserSlides.length]
      if (slide.model_id) {
        setActiveScene(slide.model_id, slide.camera_id)
      }
    }, intervalTime)
  }

  onUnmounted(() => {
    abortTimeout = true
  })

  function timeout(fn: () => void, intervalTime = 8000) {
    if (abortTimeout) return
    setTimeout(function () {
      // call fn() then recall the parent function to create a recursive loop.
      fn()
      timeout(fn, intervalTime)
    }, intervalTime)
  }

  return { startSlideAutoPlay }
}
